import Swiper from "swiper";

const buildSwiperWithAutoSlide = (sliderElm, index) => {
    const uniqueClass = `auto-slide-${index}`;
    sliderElm.classList.add(uniqueClass);
  
    // Select the navigation buttons within this specific slider element
    const nextButton = sliderElm.querySelector('.swiper-button-next');
    const prevButton = sliderElm.querySelector('.swiper-button-prev');
  
    // Add unique classes to the next and prev buttons
    if (nextButton) {
      nextButton.classList.add(`${uniqueClass}-next`);
    }
  
    if (prevButton) {
      prevButton.classList.add(`${uniqueClass}-prev`);
    }
  
    return new Swiper(`.${uniqueClass}`, {
      loop:true,
      effect: "fade",
      autoplay: {
        speed:500,
        pauseOnMouseEnter:true,
        disableOnInteraction:false,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: `.${uniqueClass}-next`,
        prevEl: `.${uniqueClass}-prev`,
      },
    });
  };
  
  document.addEventListener('DOMContentLoaded', function () {
    // Get all of the swipers on the page
    const autoSlide = document.querySelectorAll(".auto-slide");
        autoSlide.forEach((slider, i) => buildSwiperWithAutoSlide(slider, i));
  });